
import { useTranslation } from "react-i18next";
import { ApplicationStatusPage, CommonStatusPageProps } from "../../components/ApplicationStatusPage";
import { Headline } from "../../ui";

const  LoadApplicationPage = ({ navigateToCorrectStepFunc }: CommonStatusPageProps): JSX.Element => {

  const { t } = useTranslation("common");    
  
  return <ApplicationStatusPage navigateToCorrectStepFunc={navigateToCorrectStepFunc}
      correctStateFunc={() => false} >
          <Headline>{t<string>("ApplicationLandingPages.Startup.Headline")}</Headline>
          <h2>{t<string>("ApplicationLandingPages.Startup.SubHeadline")}</h2>
    </ApplicationStatusPage>
};

export default LoadApplicationPage;